import { render, staticRenderFns } from "./TaskFormEdit.vue?vue&type=template&id=b9c17950"
import script from "./TaskFormEdit.vue?vue&type=script&lang=js"
export * from "./TaskFormEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9c17950')) {
      api.createRecord('b9c17950', component.options)
    } else {
      api.reload('b9c17950', component.options)
    }
    module.hot.accept("./TaskFormEdit.vue?vue&type=template&id=b9c17950", function () {
      api.rerender('b9c17950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/task/TaskFormEdit.vue"
export default component.exports